export default "__VITE_ASSET__ec530f1b__"